<template>
  <div class="core">
    <div class="core-top">
      <div class="top-select">
        <div style="margin-right: 0.7vw"><DropDown :content="warehouseTitle" :items="warehouse" @sendInfo = "showInfoW"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择仓库" :content="buildingTitle" :items="building" @sendInfo = "showInfoB"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择楼号" :content="floorTitle" :items="floor" @sendInfo = "showInfoF"></DropDown></div>
        <div style="margin-right: 0.7vw"><DropDown message="请选择层号" :content="areaTitle" :items="area" @sendInfo = "showInfoA"></DropDown></div>
        <div class="input-wrapper"><input disabled="true" v-model="stackTitle" placeholder=""/></div>
        <div style="margin-right: 0.7vw"><DropDown content="全部养护阶段" :items="maintainStageData" @sendInfo = "showInfoS"></DropDown></div>
      </div>
      <div class="top-crib">
        <div style="display: flex;flex-direction: row;align-items:center">
          <div class="top-crib-title">垛位：</div>
          <div class="top-crib-title-num" :class="{'top-crib-title-num-active': data.sign === 1}" v-for="(data,index) in stack" v-if="index < 3" :key="index" @click="changeBg(index)">
            {{data.name}}
          </div>
          <div class="no-stack" v-if="stack.length === 0">暂无垛位</div>
          <div class="top-crib-more" v-if="stack.length > 5" @click="showCribMore = true">更多</div>
        </div>
        <div style="display: flex;flex-direction: row;align-items:center">
          <div class="input-wrapper">
            <input v-model="materialCode" placeholder="请输入烟草代码"/>
          </div>
          <div class="input-wrapper">
            <input v-model="materialName" placeholder="请输入烟草名称"/>
          </div>
          <div id="qbca" class="query button" @click="functionA">查询</div>
        </div>
      </div>
    </div>
    <div class="core-bottom" style="position: relative;z-index: 9">
      <transition :name="transitionName">
        <router-view class="Router"></router-view>
      </transition>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="showCribMore" @click="showCribMore = false">
        <div class="alert-content" style="width: 45vw">
          <div class="alert-content-title">更多垛位</div>
          <div class="alert-content-msg" style="flex-wrap: wrap;justify-content: flex-start">
            <div class="top-crib-title-num" :class="{'top-crib-title-num-active': data.sign === 1}" v-for="(data,index) in stack" :key="index" @click="changeBg(index)">
              {{data.name}}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import click from '../../../tools/click'
import DropDown from '../../../components/DropDownSingle.vue'
import {warehouseNode} from '../../../api/basic'
export default {
  name: 'Core',
  components: { DropDown },
  data () {
    return {
      showCribMore: false,
      transitionName: 'slide-fade',
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      warehouseTitle: '请选择仓库',
      buildingTitle: '请选择楼号',
      floorTitle: '请选择层号',
      areaTitle: '请选择区号',
      stackTitle: '请选择垛位',
      siteId: '',
      siteType: '',
      itemList: [
        {title: '全部', sign: 1, path: '/core'},
        {title: '温度', sign: 0, path: '/core/timeMonitoring/timeTemperature'},
        {title: '湿度', sign: 0, path: '/core/timeWater'},
        {title: '传感器配置', sign: 0, path: '/core/timeMonitoring/timeSensor'}
      ],
      maintainStageData: [
        {name: '全部养护阶段', value: ''},
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      maintainStage: '', // 养护阶段
      materialCode: '', // 烟草代码
      materialName: '' // 烟草名称
    }
  },
  created () {
    let body = {
      warehouseNodeId: '',
      warehouseNodeType: '01'
    }
    warehouseNode(body).then(res => {
      console.log(res)
      this.warehouse = res.data
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    functionA: function () {
      click.$emit('click_first', this.siteId, this.siteType, this.maintainStage, this.materialCode, this.materialName)
    },
    showInfoW: function (data) {
      this.warehouseTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '02'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.building = res.data
        this.buildingTitle = '请选择楼号'
        this.floor = []
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
        this.stackTitle = '请选择垛位'
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '03'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.floor = res.data
        this.floorTitle = '请选择层号'
        this.area = []
        this.areaTitle = '请选择区号'
        this.stack = []
        this.stackTitle = '请选择垛位'
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoF: function (data) {
      this.floorTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '04'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        this.area = res.data
        this.areaTitle = '请选择区号'
        this.stack = []
        this.stackTitle = '请选择垛位'
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoA: function (data) {
      this.areaTitle = data.name
      this.siteId = data.id
      this.siteType = data.siteType
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: '05'
      }
      warehouseNode(body).then(res => {
        console.log(res)
        res.data.map(item => {
          item.sign = 0
        })
        this.stack = res.data
        this.stackTitle = '请选择垛位'
      }).catch(err => {
        console.log(err)
      })
    },
    changeBg: function (index) {
      this.stack.map((data, ind) => {
        if (index === ind) {
          data.sign = 1
          this.stackTitle = data.name
          this.siteId = data.id
          this.siteType = data.siteType
        } else {
          data.sign = 0
        }
      })
      this.showCribMore = false
    },
    showInfoS: function (data) {
      this.maintainStage = data.value
      console.log(this.maintainStage)
    }
  }
}
</script>

<style scoped>
  @import "Core.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/Core.vue